import * as types from "./types";

const agentState = {
  agent: null,
  searchedAgent: null,
  error: null
};

export default (state = agentState, action) => {
  switch (action.type) {
    case types.CLEAR_STORE: {
      return {
        ...state,
        ...agentState
      };
    }
    case types.ADD_AGENT_SUCCESS:
    case types.FETCHING_AGENT_SUCCESS: {
      return {
        ...state,
        agent: action.payload
      };
    }
    case types.SEARCH_AGENT: {
      return {
        ...state,
        error: null
      };
    }
    case types.SEARCH_AGENT_SUCCESS: {
      return {
        ...state,
        searchedAgent: action.payload
      };
    }
    case types.CLEAR_SEARCH: {
      return {
        ...state,
        searchedAgent: null
      };
    }
    case types.SEARCH_AGENT_ERROR:
    case types.FETCHING_AGENT_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
